import { FeeType } from '@cinch-labs/logistics-fees-types'
import { feesClient } from '../fees-client'

export const getFeeTypes = async (): Promise<FeeType[]> => {
  const { data } = await feesClient.get<FeeType[]>('/fee/types')

  return data
}
